var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17969 0C1.71094 0 1.30729 0.169271 0.96875 0.507812C0.65625 0.820312 0.5 1.21094 0.5 1.67969V13.3203C0.5 13.7891 0.65625 14.1927 0.96875 14.5312C1.30729 14.8438 1.71094 15 2.17969 15H13.8203C14.2891 15 14.6797 14.8438 14.9922 14.5312C15.3307 14.1927 15.5 13.7891 15.5 13.3203V7.5H13.8203V13.3203H2.17969V1.67969H8V0H2.17969ZM12.8047 0.820312C12.6484 0.820312 12.5182 0.885417 12.4141 1.01562L11.3984 1.99219L13.4688 4.10156L14.4844 3.08594C14.6146 2.98177 14.6797 2.85156 14.6797 2.69531C14.6797 2.53906 14.6146 2.40885 14.4844 2.30469L13.1953 1.01562C13.0911 0.885417 12.9609 0.820312 12.8047 0.820312ZM10.8125 2.61719L4.67969 8.75V10.8203H6.75L12.8828 4.6875L10.8125 2.61719Z",
    fill: "#0DC4E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ec72ee7f.svg";
export { ForwardRef as ReactComponent };